import React, {useContext, useState, useEffect} from "react";
import { useQuery } from "@tanstack/react-query";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {format} from 'date-fns';
import Container from "../../Container/Container";
import SearchComponent from "../../SearchComponent/SearchComponent";
import TableComponent from "../../TableComponent/TableComponent";
import SettingsDelete from "../SettingsDelete/SettingsDelete";
import CreateUsers from "./CreateUsers/CreateUsers";
import EditUsers from "./CreateUsers/EditUsers";
import NoData from "../../NoData/NoData"
import ToastComponent from "../../ToastComponent";
import {AuthContext} from "../../../AuthContext";
import { getTableColumns } from "../../../util";
import './Users.css';

// API & Authentication
import { fetchUsers } from "../../../apis/users.api";
import usePermissions from "../../../hooks/userPermissions";

function Users() {
  const {canUserCreate, canUserUpdate, canUserDelete} = usePermissions()
  const {authData} = useContext(AuthContext);
  const {access_token, token_type} = authData
  const [searchResults, setSearchResults] = useState([])
  const [usersRows, setUsersRows] = useState([])
  const [usersColumns, setUsersColumns] = useState([])
  const [selectedUser, setSelectedUser] = useState(null);
  const [openDeleteUsers, setOpenDeleteUsers] = useState(false);
  const [openCreateUsers, setOpenCreateUsers] = useState(false);
  const [openEditUsers, setOpenEditUsers] = useState(false);
  const [isToastOpen, setIsToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorCode, setErrorCode] = useState(0);

 // create rows Data
    const createRowsData = (data) => {
      return data?.map(item => {
        if (!item?.is_deleted) {
          return {
            'User ID': item?.user_id,
            'User Name': item?.name,
            'User Email ID': item?.email,
            'No. of Projects': item?.number_of_projects,
            'No. of Organisations': item?.number_of_orgs,
            // 'Created On': format(new Date(item?.created_on), 'MM/dd/yyyy, hh:mm a'),
            // 'Updated On': format(new Date(item?.updated_on), 'MM/dd/yyyy, hh:mm a')
          }
        }
        return null;
      }).filter(item => item !== null);
    };

    // Create createColumns Data 
    const createColumnsData = (rowsData) => {
      return [...getTableColumns(rowsData), {
        "field": "action",
        "header": "Action"
      }];
    };
  useEffect(()=>{
      let settime;
      if(isToastOpen) {
        settime = setTimeout(()=>{
          setIsToastOpen(false);
        }, 4000)
      }
  
      return ()=>clearTimeout(settime);
    }, [isToastOpen])

  const {data: usersData, isLoading: loadingUsers, isFetching, refetch, error} = useQuery({
    queryKey: ['users', {access_token, token_type}],
    queryFn: fetchUsers,
    refetchOnWindowFocus: false
  })

  // Handle data processing when usersData changes
  useEffect(() => {
    if (usersData) {
      console.log("user data", usersData);
      setSearchResults(usersData);
      const rowsData = createRowsData(usersData);
      const columnsData = createColumnsData(rowsData);
      setUsersRows(rowsData);
      setUsersColumns(columnsData);
    }
  }, [usersData]);

  // Log any errors
  useEffect(() => {
    if (error) {
      console.error("Users API Error:", error);
    }
  }, [error]);

   // Users serach functionality on sereach
   const handleSearchFunctionality = (event) => {
    let resultArray=[];
    const query = event?.toLowerCase();
    if (!query){
      resultArray = usersData;
      setSearchResults(usersData);
    } else{
     resultArray = usersData?.filter(
      (data) => {    
        return data?.name?.toLowerCase().includes(query.toLowerCase())||
        data?.email?.toLowerCase().includes(query.toLowerCase());
      }  
    );
    setSearchResults(resultArray);
  }
    const rowsData = createRowsData(resultArray);
  const columnsData = createColumnsData(rowsData);
  setUsersRows(rowsData);
  setUsersColumns(columnsData);
  }

  useEffect(() => {
    if (!isToastOpen) {
      refetch();
    }
  }, [isToastOpen, refetch]);
  
  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1, height:'130vh !important' }}
        open={loadingUsers || isFetching || loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Container>
        <div className="usersContainer">
          <div className="usersHeader">
              <h2>Your Users</h2>
          </div>
          <SearchComponent 
            placeholder="Search Users"
            // onSearch={(query) => console.log(query)}
            CreateButtonTitle="Create User"
            setOpenCreateSettings={setOpenCreateUsers}
            canCreate={canUserCreate}
            onSearch={handleSearchFunctionality}
          />
          {searchResults && usersColumns.length > 0 && usersRows.length > 0 &&
            <TableComponent 
              columns={usersColumns}
              rows={usersRows}
              setSelected={setSelectedUser}
              setOpenEditSettings={setOpenEditUsers} 
              setOpenDeleteSettings={setOpenDeleteUsers}
              canUpdate={canUserUpdate}
              canDelete={canUserDelete}
            />
          }
          {searchResults?.length === 0 && <NoData main={'Users'}/>}
          {openCreateUsers &&
            <CreateUsers 
              openCreateUsers={openCreateUsers} 
              setOpenCreateUsers={setOpenCreateUsers}
              setIsToastOpen={setIsToastOpen}
              setToastMessage={setToastMessage}
              setLoading={setLoading}
              setErrorCode={setErrorCode}
            />
          }
          {openEditUsers &&
            <EditUsers 
              openEditUsers={openEditUsers} 
              setOpenEditUsers={setOpenEditUsers}
              selectedUser={selectedUser}
              setIsToastOpen={setIsToastOpen}
              setToastMessage={setToastMessage}
              setLoading={setLoading}
              setErrorCode={setErrorCode}
            />
          }
          {openDeleteUsers && 
            <SettingsDelete 
              openDeleteSettings={openDeleteUsers}
              setOpenDeleteSettings={setOpenDeleteUsers}
              title={'User'}
              mainTitle={selectedUser["User Name"] || 'User'}
              selected={selectedUser}
              setIsToastOpen={setIsToastOpen}
              setToastMessage={setToastMessage}
              setLoading={setLoading}
              setErrorCode={setErrorCode}
            />
            }
            {isToastOpen && 
              <ToastComponent 
                isToastOpen={isToastOpen} 
                setIsToastOpen={setIsToastOpen} 
                message={toastMessage}
                errorCode={errorCode}
              />
            }
        </div>
      </Container>
    </>
  );
}

export default Users;